import { STANDARD_PHYS_DESCR_FIELDS } from './constants';

const MusicPhysDescriptionFieldConfig = [...STANDARD_PHYS_DESCR_FIELDS];

export default MusicPhysDescriptionFieldConfig;
